// Merges one language's translations into the runner's testItems, without mutating them.
// Each item's Learnosity JSON is in `qti_xml` (a hash despite the name), matched to its
// translation by String(question_id). A missing field keeps English.

import { mergeChoiceMatrix } from './mergers/choiceMatrix';
import { mergeClassification } from './mergers/classification';
import { mergeMcq } from './mergers/mcq';
import { mergeOrderList } from './mergers/orderList';
import { mergeTypedAnswer } from './mergers/typedAnswer';

// Translatable fields differ by type, keyed by question_type_id.
const MERGERS = {
  204: mergeChoiceMatrix,
  205: mergeClassification,
  208: mergeTypedAnswer,
  210: mergeTypedAnswer,
  222: mergeMcq,
  225: mergeOrderList,
  264: mergeTypedAnswer,
};

export const mergeTranslations = (testItems, translations, lang) => {
  const forLanguage = (translations || {})[lang];
  if (!forLanguage) return testItems;

  return testItems.map((item) => {
    const merge = MERGERS[item.type];
    if (!merge) return item;

    const translated = forLanguage[String(item.question_id)];
    if (!translated) return item;

    return { ...item, qti_xml: merge(item.qti_xml, translated) };
  });
};
